import React from 'react'
import {Close, WarningAmber} from '@mui/icons-material'
import { Box, Button, DialogActions, IconButton, Stack } from '@mui/material'
import Dialog from '../ui/Modal'


const EditCancelConfirmationModal = ({
    label,
    isCancelClicked,
    setIsCancelClicked,
    onCancelYesClick,
    isDisabled,
    view
}:any) => {

    return (
    <Dialog
        isOpen={(isCancelClicked && !isDisabled) || (isCancelClicked && view === 'add')}
        closeModalClick={() => setIsCancelClicked(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        width="600px"
        height="400px"
    >
        <Stack sx={{p:1}}>
            <div style={{ background: "#EFF4FC" }}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <div className="modal-title-container" >
                        <span className="text-3E3E3E-20px bold">WARNING</span>
                        <span className="text-5B5B5B-14px  normal">
                            {label ? label : `All unsaved data will be lost. Are you sure you want to proceed?`}
                        </span>
                    </div>
                    <IconButton
                        onClick={() => setIsCancelClicked(false)}>
                        <Close
                            style={{cursor: "pointer"}}
                        />
                    </IconButton>
                </div>
            </div>
            <Box mt={"20px"} mb={"20px"} display={"flex"} justifyContent={"center"}>
                <Stack flexDirection={"column"}>
                    <WarningAmber color="warning" sx={{fontSize: "160px"}}/>
                </Stack>
            </Box>
            <DialogActions>
                <Stack
                    style={{ marginTop: "24px" }}
                    direction={"row"}
                    spacing={1}
                    justifyContent="flex-end"
                >
                    <Button onClick={() => setIsCancelClicked(false)} variant="outlined">
                        No
                    </Button>
                    <Button variant="contained" onClick={onCancelYesClick}>
                        Yes
                    </Button>
                </Stack>
            </DialogActions>
        </Stack>
    </Dialog>
  )
}

export default EditCancelConfirmationModal